import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from '../../../../store/slices/userSlice';
import toast from 'react-hot-toast';
import { Form, Input } from 'antd';
import LoadableButton from '../../../../components/buttons/LoadableButton';
import ModalComponent from '../../../../components/modals/ModalComponent';
import { Request2faChangeApi, Verify2faChangeApi } from '../../../../api/request/users';

const TwoFAModal = ({ isOpen, setIsOpen }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [loading, setLoading] = useState(false);
    const [FormData, setFormData] = useState({ otp: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(120);

    const verifyWithOpt = userDetails?.verifyWithOpt;

    const formatTime = (timer) => {
        const minutes = Math.floor(timer / 60);
        const remainingSeconds = timer % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    useEffect(() => {
        if (timer <= 0) return;

        const id = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(id);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(id);
    }, [timer]);


    const resendOTP = async () => {
        setLoading(true);
        try {
            const params = { IsEnable: !verifyWithOpt };
            const { data } = await Request2faChangeApi(params);
            if (data?.success) setTimer(120);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit2FA = async (values) => {
        const { otp } = values;

        if (!otp) {
            toast.error("OTP can not be empty.");
            return;
        }

        try {
            setIsLoading(true);
            const params = {
                userId: userDetails?.id,
                Otp: otp,
                isActiveFlag: !verifyWithOpt,
            };
            const { data } = await Verify2faChangeApi(params);

            if (data?.success) {
                toast.success(data?.message);
                dispatch(setUserDetails({...userDetails, verifyWithOpt: !verifyWithOpt}));
                form.resetFields();
                setIsOpen(false);
            }

            setIsLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Something went wrong");
            setIsLoading(false);
        }
    };

    return (
        <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title='Two Factor Authentication' width={600}>
            <div className='grid grid-cols-12 justify-center items-center'>
                <div className='col-span-12 flex flex-col bg-[#FFFFFF] justify-center items-center sm:px-10 px-4 sm:py-10 py-6 gap-6 w-full'>

                    <div className="text-center">
                        <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                            A verification code has been sent to your email address: {userDetails?.email}
                        </p>
                        <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                            Please enter the OTP and verify yourself
                        </p>
                    </div>
                    <div className="w-full">
                        <Form autoComplete="off" form={form} onFinish={handleSubmit2FA}>
                            <div className="w-full text-sm py-1 overflow-x-auto">
                                <div className="relative">
                                    <Form.Item name="otp" rules={[{ required: true }]}>
                                        <Input.OTP
                                            style={{ width: '100%', maxWidth: '100%' }}
                                            onChange={(e) => setFormData({ ...FormData, otp: e?.target?.value })}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="my-6 flex justify-center">
                                {
                                    timer == 0 ? (<button type="button" onClick={resendOTP} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                                }
                            </div>
                            <div className="mt-8">
                                <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' />
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </ModalComponent>
    )
}

export default TwoFAModal